import { SeverityLevel } from '@microsoft/applicationinsights-web';
import {
    AdtExplorerTenantIdStorageKey,
    ConfigurationStorageKey
} from '../Models/Constants/Constants';

export const queryParams = (function () {
    return new URLSearchParams(window.location.search);
})();

export const getUrlParam = (key: string) => {
    return queryParams.get(key);
};

export const setUrlParam = (key: string, value: string | null | undefined) => {
    if (value) {
        queryParams.set(key, value);
    } else {
        queryParams.delete(key);
    }
};

export const getSecureUrlObjFromString = (
    urlString: string | null | undefined
) => {
    let returnUrl;
    if (urlString) {
        try {
            returnUrl = new URL(urlString);
            returnUrl.protocol = 'https:';
        } catch (e) {
            if (urlString.indexOf('https://') !== 0) {
                returnUrl = new URL('https://' + urlString);
            }
        }
    }
    return returnUrl;
};

export const getADTInstanceUrlFromLocalStorage = () => {
    try {
        let configuationFromLocalStorage = localStorage.getItem(
            ConfigurationStorageKey
        );
        let adtInstanceUrl = configuationFromLocalStorage
            ? JSON.parse(configuationFromLocalStorage)?.appAdtUrl
            : '';
        return adtInstanceUrl;
    } catch (e) {
        return '';
    }
};

export const getStorageContainerUrlFromLocalStorage = () => {
    return localStorage.getItem('adtBlobContainerURL') ?? '';
};

export const getTenantIdFromLocalStorage = () => {
    return localStorage.getItem(AdtExplorerTenantIdStorageKey) ?? '';
};

export const updateParamsInUrl = (
    entries: Record<string, string | undefined>,
    shouldPushToHistory = true
) => {
    const currentParams = new URLSearchParams(window.location.search);
    if (typeof entries === 'object') {
        Object.keys(entries).forEach((k) => {
            setUrlParam(k, entries[k]);
        });
    }
    let isSame = true;
    if (Array.from(queryParams).length !== Array.from(currentParams).length) {
        isSame = false;
    } else {
        for (const [name, value] of queryParams.entries()) {
            if (currentParams.get(name) !== value) {
                isSame = false;
            }
        }
    }

    // push to history stack only when shouldPushToHistory flag is true and parameters changes
    if (shouldPushToHistory && !isSame) {
        window.history.pushState(
            {},
            '',
            window.location.href.split('?')[0] +
                (queryParams.toString() ? '?' + queryParams.toString() : '')
        );
    }
};

export const getLocalStorageJSONItem = (key: string) => {
    let value = localStorage.getItem(key);
    let returnValue = null;
    if (value) {
        try {
            returnValue = JSON.parse(value);
        } catch (err: any) {
            console.log(err.message);
            return null;
        }
    }
    return returnValue;
};

export const setLocalStorageJSONArrayItem = (
    key: string,
    value: Array<any>,
    shouldOverride: boolean = false
) => {
    if (shouldOverride) {
        localStorage.setItem(key, JSON.stringify(value));
    } else {
        const originalValue = getLocalStorageJSONItem(key);
        if (Array.isArray(originalValue)) {
            localStorage.setItem(
                key,
                JSON.stringify(originalValue.concat(value))
            );
        }
    }
};

export const isPhoneBrowser = () => {
    let browsers = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iPhone: function () {
            return navigator.userAgent.match(/iPhone|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        }
    };
    return (
        browsers.Android() ||
        browsers.BlackBerry() ||
        browsers.iPhone() ||
        browsers.Opera() ||
        browsers.Windows()
    );
};

export const languageToCodeMapping = {
    'cs-CZ': 'Čeština‎',
    'de-DE': 'Deutsch‎',
    en: 'English',
    'es-ES': 'Español‎',
    'fr-FR': 'Français‎',
    'hu-HU': 'Magyar‎',
    'it-IT': 'Italiano‎',
    'ja-JP': '日本語‎',
    'ko-KR': '한국어‎',
    'nl-NL': 'Nederlands‎',
    'pl-PL': 'Polski‎',
    pt: 'Português (Brasil)‎',
    'pt-PT': 'Português (Portugal)‎',
    'ru-RU': 'Русский‎',
    'sv-SE': 'Svenska‎',
    'tr-TR': 'Türkçe‎',
    'zh-Hans': '中文(简体)‎'
};

export const convertSeverityToAppInsightsSeverity = (
    severityLevel: 'Verbose' | 'Information' | 'Warning' | 'Error' | 'Critical'
): SeverityLevel => {
    switch (severityLevel) {
        case 'Critical':
            return SeverityLevel.Critical;
        case 'Error':
            return SeverityLevel.Error;
        case 'Information':
            return SeverityLevel.Information;
        case 'Verbose':
            return SeverityLevel.Verbose;
        case 'Warning':
            return SeverityLevel.Warning;
        default:
            return SeverityLevel.Information;
    }
};
